import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * twMerge com a escala da repaginação (app/globals.css, bloco @theme).
 * Sem isto o tailwind-merge não sabe que `text-ui`/`text-display` são
 * TAMANHO de fonte, acha que são cor e, junto com `text-ink`, apaga um dos
 * dois — a classe some em silêncio.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["3xs", "2xs", "ui", "title-sm", "title-lg", "display"],
      tracking: ["caps", "tab", "label"],
      shadow: ["popover", "window"],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
